import { render, staticRenderFns } from "./PmrTable.vue?vue&type=template&id=27ede12f&scoped=true&"
import script from "./PmrTable.vue?vue&type=script&lang=js&"
export * from "./PmrTable.vue?vue&type=script&lang=js&"
import style0 from "./PmrTable.vue?vue&type=style&index=0&id=27ede12f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ede12f",
  null
  
)

export default component.exports